import * as yup from "yup";
import { InferType } from "yup";

import { createEmailSchema, phoneNumberSchema } from "./authSchemas";
import { providerSpecialtyOptions } from "./userSchemas";

const asciiPrintableRegex = /^[ -~]*$/;

export const inviteProviderSchema = yup.object().shape({
  email: createEmailSchema(),

  specialties: yup
    .array()
    .of(yup.string().oneOf(providerSpecialtyOptions))
    .optional()
    .nullable(),

  firstName: yup
    .string()
    .required("First name is required")
    .matches(
      asciiPrintableRegex,
      "First name must contain only ASCII printable characters"
    ),

  middleName: yup
    .string()
    .optional()
    .matches(
      asciiPrintableRegex,
      "Middle name must contain only ASCII printable characters"
    ),

  lastName: yup
    .string()
    .required("Last name is required")
    .matches(
      asciiPrintableRegex,
      "Last name must contain only ASCII printable characters"
    ),

  phoneNumber: phoneNumberSchema,

  profileImage: yup.mixed<File | string>().nullable().optional(),

  npi: yup
    .string()
    .optional()
    .nullable()
    .matches(/^\d{0,10}$/, "NPI must be a valid NPI")
    .test("npi-format", "NPI must be a valid NPI", (value) => {
      if (!value || value.length === 0) return true; // Optional field
      return /^\d{1,10}$/.test(value);
    }),

  branchId: yup.string().optional().nullable(),

  roleId: yup.string().optional().nullable(),
});

// Infer the type from the schema
export type InviteProviderFormData = InferType<typeof inviteProviderSchema>;
